import { useMemo } from 'react';

import { ProjectWithContractors } from '@/shared/types/api';

type UseConnectionEditParams = {
  projectId: number;
  projects: ProjectWithContractors[] | undefined;
  onSelect: (projectId: number | null) => void;
  onOpenChange: (open: boolean) => void;
};

export function useConnectionEdit({
  projectId,
  projects,
  onSelect,
  onOpenChange,
}: UseConnectionEditParams) {
  // Filter out the current project from available projects
  const availableProjects = useMemo(
    () => projects?.filter((p) => p.id !== projectId) || [],
    [projects, projectId],
  );

  const handleSelectProject = (selectedId: number | null) => {
    onSelect(selectedId);
    onOpenChange(false);
  };

  return {
    availableProjects,
    handleSelectProject,
  };
}
